// extracted by mini-css-extract-plugin
export var attribution = "_8l-4";
export var authorName = "_8l-5";
export var quote = "_8l-3";
export var testimonial = "_8l-2";
export var trustedBy = "_8l-0";
export var trustedByLabel = "_8l-1";